// removed by extract-text-webpack-plugin
module.exports = {"view":"view__uCP0i","signUpResult":"signUpResult__10Fu4"};


//////////////////
// WEBPACK FOOTER
// ./components/signup-flow/step-result/index.sass
// module id = 691d
// module chunks = 1 5